import Joi from "joi"
import { FieldType, TextFieldType } from "../../components/fields"
import { FormComponent } from "../../components/form"
import { HeroBanner,Row,Col, BoxContainer,Text } from "../../style/base.style"
import { useDeviceType } from "../../contexts/DeviceContext"
import { useContactType } from "../../contexts/ContactContext"
import { DateTimePickerType } from "../../components/fields/DatePicker"
import { useDictionary } from "../../contexts/dictionary"
import { ActionButton, ButtonStyle } from "../../components/buttons/ActionButton"
import { useEffect, useState } from "react"
import { CheckoutLayout } from "../../components/checkout/CheckoutLayout"
import { useFormHandling } from "../../hooks/formUtils"
import { RequestConfigs } from "../../api"
import { translate } from "react-range/lib/utils"
import { add, max, set } from "date-fns"
import { routesMap } from "../../constants/routes"
import { useNavigate } from "react-router-dom"
import { TableColumn, TableComponent } from "../../components/common/TableComponent"
import { calculateAge } from "../../utils/calculators"


const AGE_40 = 40
const AGE_65 = 65

export const FamilyUpdate = () => {
    const {isMobile} = useDeviceType()
    const {contact,cart} = useContactType()
    const {translate} = useDictionary()


    const columns:TableColumn[] = [
        // {
        //     id: 'Product_Code',
        //     label:translate('code'),
        // },
        {
            id: 'Product_Name',
            label:translate('description'),
        },
       
        {
            id: 'Unit_Price',
            label: translate('price'),
            renderCell: (row:Product) => {return <Text> {row.Unit_Price} {row.$currency_symbol}</Text>},
            sumAddon:"ILS" 
        },

      
        
        
       
       
      ]

    const [familyMembers,setFamilyMembers] = useState<FamilyMember[]>([])
    const [familyMemberForm,setFamilyMemberForm] = useState<FamilyMemberFormProps | null>(null)
    const [productExtensions,setProductExtensions] = useState<Product[]>([])

    const productId = cart[0]?.product
    const navigate = useNavigate()
   
   
 


    const {handleClick,serverRes} = useFormHandling({requestType:RequestConfigs.getFamily})
    const productsForm = useFormHandling({requestType:RequestConfigs.productExtensions,params:{productId:productId}})

    useEffect(() => {
        if(!productId){
            navigate(routesMap.checkoutChoosePlan.to)
          }
        handleClick()
        productsForm.handleClick()
    },[])

    useEffect(() => {
        if(productsForm.serverRes?.productExtensions){
            setProductExtensions(productsForm.serverRes.productExtensions)
    
        }
    },[productsForm.serverRes])

    useEffect(() => {
        if(serverRes?.succeeded && serverRes?.family){
            console.log("serverRes",serverRes)
            setFamilyMembers(serverRes.family)
            
        }
    },[serverRes])


    const addFamilyMember = (isChild:boolean,familyMember?:FamilyMember) => {
      
        setFamilyMemberForm({
            isChild,
            familyMember,
            setFamilyMembers,
            setFamilyMemberForm
        })
    }


   
    const hasSpouse = familyMembers.some((item) => {
        return item.family__Is_Guardian === true
    })
    console.log("hasSpouse",hasSpouse)  



    console.log("familyMembers",familyMembers)

    const extensions  = productExtensions.sort((a, b) => a.Product_Code.localeCompare(b.Product_Code))
    console.log("extensions",extensions)  
    let kidNumber = 0  

    return (
       
          <CheckoutLayout page="add_family_members">
     <Row $width="100%" $justifyContent="center" $alignItems="center">
                <Col $width="100%" $alignItems="center" $gap={20} >
                    <BoxContainer>
                        <Text $fontWeight={600}>
                            {translate("family_info_desc")}
                        </Text>
                        <Col $alignItems="flex-start" $gap={10} $width="100%">

                       
                        {
                            extensions.length > 0 &&
                            <TableComponent
                                idColumn="Product_Code"
                                columns={columns}
                                data={extensions}
                                columnToShow={2}
                                sumRow={true}
                                />
                        }
                        </Col>
                    </BoxContainer>

                    
                      {/* {familyMembers.length===0 &&
                      <BoxContainer>
                        <Col $width={isMobile?"100%":"100%"} $alignItems={isMobile?"center":"flex-start"} >
                        <Text>{translate("add_family_question")}</Text>
                        <Row $gap={10}>
                        <ActionButton
                            label={translate("yes")}
                            onClick={() => {}}
                        />
                        <ActionButton
                            label={translate("no_lets_continue")}
                            onClick={() => {}}
                        />
                        </Row>
                    </Col>
                    </BoxContainer>
                    } */}
                    {familyMembers.length>0 && familyMembers.map((item,index) => {
                        if(!item.family__Is_Guardian ){
                            kidNumber = kidNumber + 1
                        }
                        return (
                            <FamilyMemberView key={index} kidNumber={kidNumber} extensions={extensions} familyMember={item} addFamilyMember={addFamilyMember} setFamilyMembers={setFamilyMembers}/>
                        )
                    })}

                    {familyMemberForm &&
                    <FamilyMemberForm
                        isChild={familyMemberForm.isChild}
                        familyMember={familyMemberForm.familyMember}
                        setFamilyMembers={familyMemberForm.setFamilyMembers}
                        setFamilyMemberForm={familyMemberForm.setFamilyMemberForm}
                    />
                    }
                    
                   
               

                 

                {
                    !familyMemberForm && 
                    <Row $width="100%" $justifyContent="space-between" $alignItems="center">
                    <Col>
                    <Row $gap={10}>
                        {
                            !hasSpouse &&
                            <ActionButton
                            label={translate("add_spouse")}
                            style={ButtonStyle.light}
                            onClick={() => addFamilyMember(false)}
                        />
                        }
                    
                        <ActionButton
                            label={translate("add_child")}
                            style={ButtonStyle.light}
                            onClick={() => addFamilyMember(true)}
                        />
                    </Row>
                    </Col>
                    
                    <Col>
                    <ActionButton
                            label={translate("continue")}
                            onClick={()=> {navigate(routesMap.checkoutPayment.to)}}
                        />
                    </Col>
                  </Row>
                }
                
                </Col>
            
               


               </Row>
        
          </CheckoutLayout>
      
    )
}






interface FamilyMemberViewProps{
    familyMember:FamilyMember;
    kidNumber?:number
    extensions:Product[]
    addFamilyMember:(isChild:boolean,familyMember:FamilyMember)=>void;
    setFamilyMembers:(React.Dispatch<React.SetStateAction<FamilyMember[]>>)
}

const FamilyMemberView = ({familyMember,addFamilyMember,setFamilyMembers,extensions,kidNumber}:FamilyMemberViewProps) => {
    const {translate} = useDictionary()
    const {handleClick,serverRes} = useFormHandling({requestType:RequestConfigs.deleteFamilyMember,data:{id:familyMember.id}})
    useEffect(() => {
        if(serverRes?.family){
            setFamilyMembers(serverRes.family)
        }
    },[serverRes])

    const calcExtensions = () => {
        const ext = []
        const age = calculateAge(familyMember.Date_of_Birth)

        
        if(familyMember.family__Is_Guardian){
            if(age.years>AGE_65){
                const elderExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "65+ Spouse")
                ext.push(elderExtensions)
                console.log("elderExtensions",elderExtensions)
            } else if(age.years>AGE_40){
                const elderExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "40+ Spouse")
                ext.push(elderExtensions)
                console.log("elderExtensions",elderExtensions)
            } else {
                const spouseExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "Spouse")
                ext.push(spouseExtensions)
                console.log("spouseExtensions",spouseExtensions)
            }

        } else {
           const firstChildExtensions = extensions.find((item) => item.payments0__Extension_Type	 === "Child")
                ext.push(firstChildExtensions)
                console.log("firstChildExtensions",firstChildExtensions)
        }

        
        return ext
        
      

    }

    const ext = calcExtensions()

    return (
        <BoxContainer>

       
        <Row $width="100%" $justifyContent="space-between" $alignItems="center">
            <Col $width="30%" $alignItems="flex-start">
            <Text>{familyMember.Full_Name}</Text>
            <Text>{familyMember.family__Is_Guardian?translate("parent"):translate("child")}</Text>
            </Col>
            
         
           <Col $width="30%">
            {
                ext.length > 0 &&
                <Text> {ext.map((item) => {
                    return item?.Product_Name + " " + item?.Unit_Price+item?.$currency_symbol
                }).join(", ")}</Text>
            }
            
          </Col>
        
        <Col $width="30%"> 
      
           <Row $gap={10}>
            <ActionButton
                label={translate("edit")}
                style={ButtonStyle.light}
                onClick={()=>{addFamilyMember(!!familyMember.family__Is_Guardian,familyMember)}}
            />
            <ActionButton
                label={translate("delete")}
                onClick={handleClick}
                style={ButtonStyle.red}
            />

            </Row>
            </Col>
         
        </Row>
        </BoxContainer>
    )
}



interface FamilyMemberFormProps{
    isChild?:boolean
    familyMember?:FamilyMember
    setFamilyMembers:(React.Dispatch<React.SetStateAction<FamilyMember[]>>)
    setFamilyMemberForm:(React.Dispatch<React.SetStateAction<FamilyMemberFormProps | null>>)
}

const FamilyMemberForm = ({isChild,setFamilyMembers,familyMember,setFamilyMemberForm}:FamilyMemberFormProps) => {

    const [form,setForm] = useState<any>({family__Is_Guardian:!isChild})
    const handleChange = (name:string,value:any) => {
        setForm((prev:any) => {
            const newForm =  {
                ...prev,
                [name]:value
            }
            return newForm
        })

    }

    useEffect(() => {
        if(familyMember){
            handleChange("id",familyMember.id)
        }
    },[])

    

    const updateForm = useFormHandling({requestType:RequestConfigs.updateFamilyMember,data:form})
    const createForm = useFormHandling({requestType:RequestConfigs.createFamilyMember,data:form})

    useEffect(() => {
        if(updateForm.serverRes?.family){
            setFamilyMembers(updateForm.serverRes?.family)
            setFamilyMemberForm(null)
        }
        if(createForm.serverRes?.family){
            setFamilyMembers(createForm.serverRes.family)
            setFamilyMemberForm(null)
        }
    },
    [updateForm.serverRes,createForm.serverRes])


    const fields:FieldConfig[] = [
        {
            name:"First_Name",
            label:"First Name",
            type:FieldType.text,
            joiSchema:Joi.string().required(),
            defaultValue:familyMember?.First_Name,
            typeOptions:{
                type:TextFieldType.text
            }
        },
        {
            name:"Last_Name",
            label:"Last Name",
            type:FieldType.text,
            defaultValue:familyMember?.Last_Name,
            joiSchema:Joi.string().required(),
            typeOptions:{
                type:TextFieldType.text
            }
        },
        {
            name:"payments0__Gov_Id",
            label:"Id",
            type:FieldType.text,
            defaultValue:familyMember?.payments0__Gov_Id,
            joiSchema:Joi.string().length(9).required(),
            typeOptions:{
                type:TextFieldType.text,
                maxLength:9,
            }
        },
        {
            name:"Date_of_Birth",
            label:"Date Of Birth",
            type:FieldType.dateTime,
            defaultValue:familyMember?.Date_of_Birth,
            joiSchema:Joi.string().required(),
            // defaultValue:contact?.Date_of_Birth,
            typeOptions:{
                dateType:DateTimePickerType.date
            }
        },
        {
            name:"Salutation",
            label:"Salutation",
            type:FieldType.select,
            defaultValue:familyMember?.Salutation,
            joiSchema:Joi.string().required(),
            typeOptions:{
                options:[
                    {label:"Mr.",value:"Mr."},
                    {label:"Mrs.",value:"Mrs."},
                    {label:"Miss.",value:"Miss."},
                    {label:"Master.",value:"Master."},
                    
                ]
            }
        },
        {
            name:"Email",
            label:"Email",
            type:FieldType.text,
            defaultValue:familyMember?.Email,
            joiSchema:Joi.string().required(),
            hide:!!isChild,
            typeOptions:{
                type:TextFieldType.text
            }

        },
        {
            name:"Phone",
            label:"Phone",
            type:FieldType.text,
            defaultValue:familyMember?.Phone,
            joiSchema:Joi.string().required(),
            hide:!!isChild,
            typeOptions:{
                type:TextFieldType.text
            }
        },
    ]
    const {isMobile} = useDeviceType()
    const {translate} = useDictionary()
    return (
        <BoxContainer>
        <Col $width={isMobile?"100%":"100%"} $alignItems={isMobile?"center":"flex-start"} >
    <FormComponent
        fields={fields}
        onChange={handleChange}
        serverRes={familyMember?updateForm.serverRes:createForm.serverRes}
        />
        </Col>
        <Row $gap={10}>

        { familyMember &&
        <ActionButton
            label="Update"
            onClick={() => {updateForm.handleClick()}}
        />
        }

    { !familyMember &&
        <ActionButton
            label={translate("add")}
            onClick={() => {createForm.handleClick()}}
        />
        }

        <ActionButton
            label={translate("cancel")}
            style={ButtonStyle.red}
            onClick={() => {setFamilyMemberForm(null)}}
        />


        </Row>

        
    </BoxContainer> 
    

    )
}